import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid o-grid--align-middle"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 row-label" }
const _hoisted_3 = {
  key: 0,
  class: "u-form-heading unset-text-align"
}
const _hoisted_4 = {
  key: 1,
  class: "row_label__fix"
}
const _hoisted_5 = {
  key: 0,
  class: "c-modal",
  "data-modal": ""
}
const _hoisted_6 = { class: "c-modal__content" }
const _hoisted_7 = { class: "c-modal__header" }
const _hoisted_8 = { class: "c-modal__title" }
const _hoisted_9 = { class: "c-modal__content-section" }
const _hoisted_10 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_11 = { class: "c-form-control" }
const _hoisted_12 = ["name", "value", "data-cy", "aria-label"]
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_ctx.sollSichtbarSein())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.props.tarifoptionentitel !== undefined)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.props.tarifoptionentitel), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.titelText) + " ", 1),
                (_ctx.zeigeInfoItem())
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "gev19__contexthelp-open",
                      title: "Hilfe anzeigen",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wechsleSichtbarkeit(_ctx.props.tarifoptionInformation?.infoItem?.name)))
                    }))
                  : _createCommentVNode("", true)
              ]))
        ]),
        (_ctx.zeigeInfoItem())
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("section", _hoisted_6, [
                _createElementVNode("header", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.props.tarifoptionInformation?.infoItem?.titel), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "c-button c-button--icon-only-white",
                    "data-modal-hide": "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit(_ctx.props.tarifoptionInformation?.infoItem?.name)))
                  }, [
                    _createVNode(_component_icon_sprite, { "icon-name": "icon-cross" }),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "c-button__visually-hidden" }, "close", -1))
                  ])
                ]),
                _createElementVNode("section", _hoisted_9, _toDisplayString(_ctx.props.tarifoptionInformation?.infoItem?.text), 1)
              ])
            ], 512)), [
              [_vShow, _ctx.istSichtbar(_ctx.props.tarifoptionInformation?.infoItem?.name)]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("select", {
              name: _ctx.props.tarifoptionInformation.selectname,
              value: _ctx.modelValue,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.inputChangeHandler($event)))),
              class: "chooseOptionsSelect c-form-control-select u-text-align-center u-mar-0",
              "data-cy": _ctx.props.tarifoptionInformation.selectname,
              "aria-label": _ctx.props.tarifoptionInformation.selectname
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.tarifoptionInformation.selectoptionen, (option, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: option.value
                }, _toDisplayString(option.label), 9, _hoisted_13))
              }), 128))
            ], 40, _hoisted_12)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}